import LetterTile from "@/components/LetterTile";

// Group slot positions into words for visual spacing.
function splitIntoWords(positions) {
  const words = [];
  let current = [];
  positions.forEach((p) => {
    if (p.type === "space") {
      if (current.length) words.push(current);
      current = [];
    } else {
      current.push(p);
    }
  });
  if (current.length) words.push(current);
  return words;
}

export default function GameBoard({ positions, slots, activeSlot, onSlotClick }) {
  const words = splitIntoWords(positions);

  return (
    <div
      className="flex flex-wrap justify-center gap-x-5 md:gap-x-8 gap-y-5 md:gap-y-7 py-6 md:py-10"
      data-testid="game-board"
    >
      {words.map((word) => {
        // Use the first slot index in the word as a stable key (unique per word).
        const wordKey = `w-${word[0].slotIndex}`;
        return (
          <div key={wordKey} className="flex gap-1.5 md:gap-2">
            {word.map(({ slotIndex }) => {
              const slot = slots[slotIndex];
              if (!slot) return null;
              return (
                <LetterTile
                  key={slotIndex}
                  slot={slot}
                  slotIndex={slotIndex}
                  isActive={activeSlot === slotIndex && !slot.locked}
                  onClick={onSlotClick}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
